























































import { Vue, Component } from "vue-property-decorator";
import UploadFile from "./uploadFile.vue";
import { validateForm, validateRequired, validateInt, validateNumber } from "./validate.js";

@Component({
  components: {
    UploadFile
  }
})
export default class RegisterStepOne extends Vue {
  //status 1 已完成 2 进行中 3未完成
  stepList = [
    {
      step: 1,
      text: "选择业务范围",
      status: 1
    },
    {
      step: 2,
      text: "填写公司基本信息",
      status: 1
    },
    {
      step: 3,
      text: "填写公司经营信息",
      status: 2
    },
    {
      step: 4,
      text: "填写业务联系人信息",
      status: 3
    },
    {
      step: 5,
      text: "完成登记",
      status: 3
    }
  ];
  dataList = [
    {
      data: '',
      label: "公司营业额",
      placeholder: "前年营业额",
      warn: "请输入公司前年营业额",
      require: true,
      suffix: "元",
      name: 'beforeLastTurnover',
      errMessage: {
        show: false,
        text: ""
      },
      validate: validateNumber
    },
    {
      data: '',
      label: "公司营业额",
      placeholder: "去年营业额",
      warn: "请输入公司去年营业额",
      require: true,
      suffix: "元",
      name: 'lastTurnover',
      errMessage: {
        show: false,
        text: ""
      },
      validate: validateNumber
    },
    {
      data: '',
      label: "公司营业额",
      placeholder: "今年至今营业额",
      warn: "请输入公司今年至今营业额",
      require: true,
      suffix: "元",
      name: 'presentTurnover',
      errMessage: {
        show: false,
        text: ""
      },
      validate: validateNumber
    },
    {
      data: '',
      label: "利润率",
      placeholder: "前年利润率",
      warn: "请输入公司前年利润率",
      require: true,
      suffix: "%",
      name: 'beforeLastProfitMargin',
      errMessage: {
        show: false,
        text: ""
      },
      validate: validateNumber
    },
    {
      data: '',
      label: "利润率",
      placeholder: "去年利润率",
      warn: "请输入公司去年利润率",
      require: true,
      suffix: "%",
      name: 'lastProfitMargin',
      errMessage: {
        show: false,
        text: ""
      },
      validate: validateNumber
    },
    {
      data: '',
      label: "利润率",
      placeholder: "今年至今利润率",
      warn: "请输入公司今年至今利润率",
      require: true,
      suffix: "%",
      name: 'presentProfitMargin',
      errMessage: {
        show: false,
        text: ""
      },
      validate: validateNumber
    },
    {
      data: "",
      label: "财报附件",
      placeholder: "请上传财报附件",
      warn: "请上传财报附件",
      require: true,
      name: 'financialAnnex',
      errMessage: {
        show: false,
        text: ""
      },
      validate: validateRequired
    },
    {
      data: "",
      label: "主要客户名称",
      placeholder: "请输入贵司排名前三的名称",
      warn: "请输入主要客户名称",
      require: true,
      name: 'customerName',
      errMessage: {
        show: false,
        text: ""
      },
      validate: validateRequired
    },
    {
      data: '',
      label: "行业排名",
      placeholder: "请输入行业排名",
      warn: "请输入行业排名",
      require: true,
      name: 'industryRanking',
      errMessage: {
        show: false,
        text: ""
      },
      validate: validateInt
    }
  ];

  mounted() {
    // 添加用于判断是 c端 还是 b端的 local storageconst
  }
  onStep(step: number) {
    if (step == -1) {
      return this.$emit("onStep", step);
    }

    const result = validateForm(this.dataList);
    !result && this.$emit("onStep", step, this.dataList);
  }
  validateInt(number: string) {
    return /^[0-9]*[1-9][0-9]*$/.test(number);
  }
}
